import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-24" data-mp="1lc1yr8r0kvp2">
      <div className="mx-auto max-w-3xl px-5" data-id="element-25" data-mp="1ge0ewllrkscj">
        <div className="text-center" data-id="element-26" data-mp="2e0fwroi3rs0m">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-27" data-mp="2dzeo1qok7hm2">
            Preguntas frecuentes
          </span>
          <h2 id="faq-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-28" data-mp="28za23l4vtuog">
            Todo lo que querés saber antes de empezar
          </h2>
        </div>

        <div className="mt-10 divide-y divide-wool border-y border-wool" data-id="element-29" data-mp="1z59qd0f3hr6r">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-30" data-mp="nn8pq83493yp" data-mpi={index}>
                <h3 data-id="element-31" data-mp="nqd1bqiwv1ze">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta" data-id="element-32" data-mp="pi7jilfh74p1">
                    <span className="font-display text-lg font-bold text-ink" data-id="element-33" data-mp="kil5wavqjmfp">{faq.question}</span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.2
                }} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cream text-terracotta" data-id="element-34" data-mp="6rq1pbw6ltig">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="3swk1hbesp5so" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-36" data-mp="3jz19to6nbt7t">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-37" data-mp="3nzk37mo6t7c4">
                      <p className="pb-6 pr-12 text-[15px] leading-relaxed text-muted" data-id="element-38" data-mp="1fsq36q5ktw6q">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}